export default "__VITE_ASSET__19c95017__"